import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import {default as _rollupMoment} from 'moment';
import {Field} from '../shared';
import {DateFieldDefinition} from './date.model';

const moment = _rollupMoment || _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class DateComponent implements OnInit, OnChanges {
  @Input() field!: Field<DateFieldDefinition>;
  @Input() group: any;
  @Input() appearance: any;

  value?: Date;

  MinDate: Date = new Date(1900, 0, 0);

  startView: 'month' | 'year' | 'multi-year' = 'month';
  min: Date | null = null;
  max: Date | null = null;
  initialDate: Date | null = null;

  constructor() { }

  ngOnInit(): void {
    if (this.field) {
      this.setCurrentValue(this.field);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.field && changes.field.currentValue !== changes.field.previousValue) {
      const currentField = changes.field.currentValue;
      this.setCurrentValue(currentField);
    }
  }

  setCurrentValue(field: Field<DateFieldDefinition>): void {
    this.startView = field.fieldDefinition?.initialDateView || 'month';
    this.min = field.fieldDefinition?.minDate && new Date(field.fieldDefinition.minDate) || this.MinDate;
    this.max = field.fieldDefinition?.maxDate && new Date(field.fieldDefinition.maxDate) || new Date();
    if (field.fieldDefinition?.initialDate) {
      this.initialDate = new Date(field.fieldDefinition.initialDate);
    } else if (this.max) {
      this.initialDate = this.max;
    } else {
      this.initialDate = new Date();
    }
  }

}
